import Yup from '../../../../utils/yup';
import { rucValidator } from '../../../Validations';

export function validationFunctionPropertyRegime(values) {
  const errors = {};
  // Custom Validations
  return errors;
}

export const validationSchemaPropertyRegime = Yup.object().shape({
  name: Yup.string()
    .max(100, 'Maximo 100 caracteres')
    .required(),
});
